
/* eslint-disable global-require */
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AppTheme } from '@/features/common/constants';

@Component
export default class ImageProvider extends Vue {
  @Prop({ default: '' }) imageName!: string;

  @Prop({ default: '' }) encodedImage!: string;

  @Prop({ default: false }) isBg!: boolean;

  @Prop({ default: 'div' }) tag!: string;

  get appTheme(): AppTheme {
    return this.$store.getters.getAppTheme;
  }

  get src(): string {
    if (this.encodedImage) {
      return `data:image/png;base64,${this.encodedImage}`;
    }

    const imagesPath = `assets${this.appTheme === AppTheme.Default ? '' : `/${this.appTheme}`}/images`;
    const fullPath = `${imagesPath}/${this.imageName}`;

    return fullPath;
  }

  get component(): string {
    return this.isBg ? this.tag : 'img';
  }

  private getStyles(): { [key: string]: string } | null {
    if (!this.isBg) return null;

    return {
      backgroundImage: `url(${require(`@/${this.src}`)}`,
    };
  }
}
